const LOCAL_STORAGE_KEY = 'mf-localstorage-dev';
function setLocalMFs(localMfs) {
    try {
        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localMfs));
    }
    catch (error) {
        console.error('Error setting local MFs', error);
    }
}
function getLocalMFs() {
    try {
        const item = window.localStorage?.getItem(LOCAL_STORAGE_KEY) || '[]';
        return JSON.parse(item);
    }
    catch (error) {
        console.error('Error getting local MFs', error);
        return [];
    }
}
function extractLocalMFs() {
    return getLocalMFs().reduce((acc, value) => {
        acc[value.name] = acc[value.name] || {};
        acc[value.name].endpoint = value.endpoint;
        acc[value.name].version = value.version;
        acc[value.name].active = value.active;
        return acc;
    }, {});
}
function shouldUseLocal(MFname) {
    return extractLocalMFs()[MFname]?.active || false;
}

export { LOCAL_STORAGE_KEY, extractLocalMFs, getLocalMFs, setLocalMFs, shouldUseLocal };
